import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/industries.css';
import mediaEntertainmentImg from '../../assets/entertainment.jpg';

const MediaEntertainment = () => (
  <div
    className="industry-page"
    style={{ backgroundImage: `url(${mediaEntertainmentImg})` }}
  >
    <motion.div
      className="industry-content"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>Media & Entertainment</h1>
      <p>
        Crafting OTT and digital media platforms that engage, stream, and scale with your audience.
      </p>
      <ul className="bullet-points">
        <li>📺 OTT & streaming apps.</li>
        <li>🎬 Content recommendation engines.</li>
        <li>📡 Real-time broadcasting tools.</li>
        <li>📱 Multi-device media experience.</li>
        <li>🌐 Scalable social media platforms.</li>
      </ul>
    </motion.div>
  </div>
);

export default MediaEntertainment;
